var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.goBackLink}},[_vm._t("default",function(){return [_c('div',{staticClass:"back-link"},[_vm._v("« Назад")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }